import styled from 'styled-components';
import { backgroundImage } from '../../../contants';
import educationImage from '../../../assets/education.png';
// import LinkButton from '../../LinkButton/LinkButton';
// import { useState } from 'react';

// const value = 'More';

const EducationTile = () => {
  return (
    <Wrapper>
      <ProjectBackgroundImage alt='error' src={backgroundImage.project2} />
      <ContentWrapper>
        <Header>Education</Header>
        <EducationImage src={educationImage} />
      </ContentWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  height: 100%;
  border-radius: 24px;
`;

const ContentWrapper = styled.div`
  position: absolute;
  padding: 40px 44px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  @media (max-width: 500px) {
    padding: 20px 22px;
  }
`;
const Header = styled.div`
  color: ${({ theme }) => theme.background};
  filter: drop-shadow(0.1rem 0.1rem 0.2rem hsla(0, 24%, 30%, 0.3));
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 8px;
  line-height: 32px;
  z-index: 2;
`;

const ProjectBackgroundImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
`;

const EducationImage = styled.img`
  height: 100%;
  width: 100%;
  object-fit: cover;
  position: absolute;
  top: 24px;
  left: 0;
  z-index: 1;
  filter: drop-shadow(0.1rem 0.1rem 0.2rem rgba(0, 0, 0, 0.1));
`;
// const LinkButtonWrapper = styled.div`
//   position: absolute;
//   bottom: 14px;
//   left: 14px;
//   width: fit-content;
// `;

export default EducationTile;
